import { Menu } from '@mui/material';
import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';
import { marginLeft, marginRight } from 'utils';

export const StyledUiTabs = styled('span')(
  ({ theme }) => css`
    box-sizing: border-box;
    .ui-tabs-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 16px 0;
      border-bottom: 1px solid #edf2f7;
      position: relative;

      // desc: چون هدر تب ها استیکی هست برای اینکه سمت چپ و راست ان سایه ها مشخص نباشن
      &:after {
        content: '';
        position: absolute;
        width: 64px;
        height: 48px;
        background-color: #fcfcfc;
        left: -64px;
        bottom: 0;
      }
      &:before {
        content: '';
        position: absolute;
        width: 31px;
        height: 48px;
        background-color: #fcfcfc;
        right: -31px;
        bottom: 0;
      }

      .MuiTabs-root {
        direction: ltr;
        .MuiTabs-scroller {
          .MuiTabs-flexContainer {
            min-height: 48px;
          }
          .MuiButtonBase-root:first-child {
            ${marginRight(0)}
          }
          .MuiButtonBase-root {
            flex-direction: row;
            font-weight: 700;
            font-size: 1rem;
            font-family: inherit;
            color: #6c879b;
            border-radius: 0 !important;
            min-height: 48px;
            padding: 0 !important;
            margin: 0px 15px;
            min-width: 40px;
            direction: rtl;
            &.custom-tab {
              min-width: unset;
              .icon {
                font-weight: 500;
                ${marginLeft('5px')}
              }
              .title {
                display: flex;
                align-items: center;
                .sub-title {
                  font-style: normal;
                  font-weight: 700;
                  font-size: 0.75rem;
                  line-height: 24px;
                  color: #0f5e62;
                  padding: 0px 6px;
                  background-color: #aadbdd;
                  border-radius: 8px;
                  ${marginRight('4px')}
                }
                .MuiSkeleton-root {
                  background-color: #aadbdd;
                  border-radius: 8px;
                  margin-right: 4px;
                  display: inline-flex;
                  box-sizing: border-box;
                }
              }
            }
            .MuiTab-iconWrapper {
              font-weight: 500;
              margin: 0;
              ${marginLeft('5px')}
            }
          }
          .MuiButtonBase-root.Mui-selected {
            background-color: transparent !important;
            color: black !important;
          }
          .MuiTabs-indicator {
            height: 2.4px;
            border-radius: 5px;
            background-color: #199da3;
          }
        }
      }

      .ui-tabs-actions {
        ${marginRight('10px')}
        white-space: nowrap;
      }

      /**
       * Opt-in spacing, requested only for the contents and resources pages.
       * Pages ask for it by adding is-compact-tabs to the className they pass,
       * so every other UiTabs keeps the default 15px side margins.
       */
      &.is-compact-tabs {
        .MuiTabs-root .MuiTabs-scroller {
          .MuiTabs-flexContainer {
            gap: 16px;
          }
          .MuiButtonBase-root,
          .MuiButtonBase-root:first-child {
            margin: 0;
          }
        }
      }

      .ui-tabs-tabs-row {
        display: flex;
        align-items: center;
        min-width: 0;
        gap: 16px;

        .MuiTabs-root {
          min-width: 0;
        }
      }

      .ui-tabs-overflow-trigger {
        display: flex;
        align-items: center;
        gap: 4px;
        flex-shrink: 0;
        /* No side padding, so the 16px row gap is the whole distance to the
           last tab and matches the spacing between tabs themselves */
        padding: 12px 0;
        cursor: pointer;
        font-weight: 700;
        font-size: 0.875rem;
        font-family: inherit;
        color: #0c395a;

        .icon {
          font-weight: 500;
        }

        .overflow-badge {
          display: flex;
          align-items: center;
          justify-content: center;
          box-sizing: border-box;
          height: 16px;
          font-style: normal;
          font-weight: 700;
          font-size: 0.75rem;
          line-height: 24px;
          color: ${theme.palette.primary.darker};
          padding: 0px 6px;
          background-color: ${theme.palette.secondary.lightest};
          border-radius: 8px;
        }
      }

      /**
       * Collapsed mobile layout: the bar becomes one select box, so the
       * underline and the sticky-shadow masks around it are dropped.
       */
      &.is-collapsed {
        border-bottom: none;

        &:after,
        &:before {
          content: none;
        }
      }

      .ui-tabs-select-trigger {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        width: 100%;
        box-sizing: border-box;
        height: 48px;
        padding: 12px;
        border: 1px solid ${theme.palette.gray.light};
        border-radius: 6px;
        background-color: ${theme.palette.common.white};
        cursor: pointer;
        font-family: inherit;

        .ui-tabs-select-value {
          display: flex;
          align-items: center;
          gap: 8px;
          min-width: 0;

          .icon {
            font-weight: 500;
          }

          .select-label {
            font-weight: 700;
            font-size: 0.875rem;
            line-height: 24px;
            color: ${theme.palette.secondary.light};
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          .sub-title {
            display: flex;
            align-items: center;
            justify-content: center;
            box-sizing: border-box;
            flex-shrink: 0;
            height: 16px;
            font-style: normal;
            font-weight: 700;
            font-size: 0.75rem;
            line-height: 24px;
            color: ${theme.palette.primary.darker};
            padding: 0px 6px;
            background-color: ${theme.palette.primary.lightest};
            border-radius: 8px;
          }

          .MuiSkeleton-root {
            background-color: ${theme.palette.primary.lightest};
            border-radius: 8px;
            flex-shrink: 0;
          }
        }
      }
    }
  `
);

/**
 * MUI Menu renders its content (Paper/List) in a Portal outside StyledUiTabs, so
 * it has to be styled directly on the Menu itself, following the existing pattern
 * in UiMenu.js. The className passed to Menu lands on the Popover root, which
 * contains the Paper, so descendant selectors like .MuiPaper-root work.
 */
export const StyledUiTabsOverflowMenu = styled(Menu)(
  ({ theme }) => css`
    .MuiPaper-root {
      background-color: ${theme.palette.common.white};
      border: 1px solid ${theme.palette.gray.lighter};
      box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.05);
      border-radius: 8px;
      padding: 8px;
    }

    .MuiList-root {
      padding: 0;
      display: flex;
      flex-direction: column;
      gap: 6px;
    }

    .MuiMenuItem-root {
      /* min-width keeps the desktop overflow menu at its designed size, while
         the mobile select stretches items to the width copied from the trigger.
         Widened so a long platform title never touches the count badge — gap
         below is the actual guarantee, this just gives it room to apply. */
      min-width: 220px;
      width: 100%;
      box-sizing: border-box;
      padding: 6px 8px;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 8px;
      font-weight: 700;
      font-size: 0.875rem;
      font-family: inherit;
      color: ${theme.palette.secondary.light};
      white-space: normal;

      .overflow-item-title {
        display: flex;
        align-items: center;
        gap: 8px;

        .icon {
          font-weight: 500;
        }
      }

      .sub-title {
        display: flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        height: 16px;
        font-style: normal;
        font-weight: 700;
        font-size: 0.75rem;
        line-height: 24px;
        color: ${theme.palette.primary.darker};
        padding: 0px 6px;
        background-color: ${theme.palette.primary.lightest};
        border-radius: 8px;
      }

      /**
       * style.scss ships a global .Mui-selected rule (white on #37aaaf, fixed
       * height) marked !important, so the active row has to outrank it.
       */
      &.Mui-selected {
        height: auto !important;
        color: ${theme.palette.primary.main} !important;
        background-color: ${theme.palette.secondary.lightest} !important;
        border-radius: 6px !important;
      }

      &:hover,
      &.Mui-selected:hover {
        background-color: ${theme.palette.secondary.lightest};
      }
    }
  `
);
